export const FAQ_URL =
  'https://clubteam.hotmart.host/nova-pagina-0dc57649-0403-4302-923d-91676084e150'
